import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { MdOutlineBlock, MdDeleteForever } from 'react-icons/md';
import Loader from '../Loader';
import { toast } from 'sonner';

const Reports = () => {
  
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(15);
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [request_title, setRequest_title] = useState('')
  const [storage_key, setStorage_key] = useState('')
  const [from_timestamp, setFrom_timestamp] = useState('')
  const [until_timestamp, setUntil_timestamp] = useState('')
  const [fromDate, setFromDate] = useState('');
  const [untilDate, setUntilDate] = useState('');



  // Fetch reports 
  const getReports = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      let query = `?offset=${(currentPage - 1) * recordsPerPage}&limit=${recordsPerPage}`;

      if (startDate && endDate) {
        query += `&start_date=${startDate}&end_date=${endDate}`
      } else if (startDate) {
        query += `&start_date=${startDate}`
      }
      
      const response = await axios.get(`/reports/${query}`);
      setReports(response.data.items);
      setCount(response.data.count);
      setTotal(response.data.total);
    } catch (error) {
      console.error(error);
      setError('Error fetching data. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [currentPage, recordsPerPage, startDate, endDate]);

  // Handle search button click
  const handleSearch = () => {
    setCurrentPage(1);
    getReports();
  };

  // Handle clearing search inputs
  const handleClearSearch = () => {
    setStartDate('');
    setEndDate('');
  };

  // Handle page change
  useEffect(() => {
    getReports();
  }, [getReports, currentPage, recordsPerPage]);

  function generateUniqueFourDigitNumber() {
    const digits = new Set();
  
    // First digit: 1–9 (to avoid leading zero)
    digits.add(Math.floor(Math.random() * 9) + 1);
  
    // Add 3 more unique digits (can include 0 now)
    while (digits.size < 4) {
      digits.add(Math.floor(Math.random() * 10));
    }
  
    return Array.from(digits).join('');
  }

  const uniqueNumber = generateUniqueFourDigitNumber();


  useEffect(() => {
    if (fromDate && untilDate) {
      setRequest_title(`Report-${fromDate}-${untilDate}`);
      setStorage_key(`Report-${uniqueNumber}-${fromDate}-${untilDate}.csv`);
    }
  }, [uniqueNumber, fromDate, untilDate]);

  // Add new report
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/reports/', {
        request_title, storage_key, from_timestamp, until_timestamp
      });
      toast.success('Report added successfully!');
      document.getElementById('my_modal_3').close();
      setFrom_timestamp('');
      setUntil_timestamp('');
      getReports();
    } catch (error) {
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to add report.')
      }
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this report!');
    if (confirmed) {
      try {
        await axios.delete(`/reports/${id}`)
        toast.success('Report Deleted')
        getReports();
      } catch (error) {
        if (!error?.response) {
          toast.error('Network error! Check your connection.');
        } else if (error.response.status) {
          toast.error(error.response.data.detail)
        } else {
          toast.error('Oops! Something went wrong. Failed to delete report.')
        }
        console.log(error);
      }
    }
  }


  return (
    <div className='mx-auto p-4'>
      <h3 className="my-2"><b>Reports</b></h3>
      <div className='bg-white rounded-lg p-4 xl:w-[78vw] 2xl:w-full'>
        <div className="flex flex-wrap items-center justify-between py-2">
          <div className='py-2 flex flex-wrap gap-2'>
            <input
              type="date"
              className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 rounded-md'
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              type="date"
              className='px-2 py-1 border bg-[#f2f9ff] border-slate-300 rounded-md'
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              onClick={handleSearch}
              className='px-4 py-1 bg-[#2b1e3e] text-white rounded-md'
            >
              Search
            </button>
            <button
              onClick={handleClearSearch}
              className='px-4 py-1 bg-red-500 text-white rounded-md'
            >
              Clear
            </button>
          </div>
          <button onClick={()=>document.getElementById('my_modal_3').showModal()} className='bg-[#134463] text-white px-4 py-1 hover:bg-[#2b1e3e] rounded-lg'>Add Report</button>
          <dialog id="my_modal_3" className="modal">
            <div className="modal-box">
              <form method="dialog">
                {/* if there is a button in form, it will close the modal */}
                <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
              </form>
              <h3 className='text-xl text-center font-bold text-[#134463]'>Add New Reports.</h3>
              <form onSubmit={handleSubmit}>
                <div className='mt-2'>
                  <label htmlFor='time'>From
                  <input
                    type='date'
                    required
                    className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                      setFrom_timestamp(new Date(e.target.value).getTime());
                    }}
                  />
                  </label>
                </div>
                <div className='mt-2'>
                  <label htmlFor='time'>Until
                  <input
                    type='date'
                    required
                    className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] w-full rounded-md focus:ring-1'
                    value={untilDate}
                    onChange={(e) => {
                      setUntilDate(e.target.value);
                      setUntil_timestamp(new Date(e.target.value).getTime());
                    }}
                  />
                  </label>
                </div>
                <div className='py-3'>
                  <button type='submit' disabled={loading} className='bg-[#2b1e3e] text-white px-5 py-1 w-full rounded-md hover:bg-[#134463]'>{loading ? 'Please wait...' : 'Add Report'}</button>
                </div>
              </form>
            </div>
          </dialog>
        </div>


        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='grid place-items-center bg-[#eef1ff] h-[70vh]'>
            <div className='text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        )  : (
          <div className='overflow-x-auto rounded-lg'>
            {reports.length > 0 ? (
              <table className='w-full text-left table-auto'>
                <thead>
                  <tr className='border-b border-slate-500'>
                    <th className='p-2'>Request Title</th>
                    <th className='p-2'>Storage Key</th>
                    <th className='p-2'>Status</th>
                    <th className='p-2'>From Timestamp</th>
                    <th className='p-2'>Until Timestamp</th>
                    <th className='p-2'>Created At</th>
                    <th className='p-2'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((report) => (
                    <tr key={report.id}>
                      <td className='p-2'>{report.request_title}</td>
                      <td className='p-2'>{report.storage_key}</td>
                      <td className='p-2'>{report.status}</td>
                      <td className='p-2'>{new Date(report.from_timestamp).toLocaleDateString("en-CA")}</td>
                      <td className='p-2'>{new Date(report.until_timestamp).toLocaleDateString("en-CA")}</td>
                      <td className='p-2'>{new Date(report.created_at).toLocaleString("en-CA", { hour12: false })}</td>
                      <td className='p-2 flex items-center justify-center gap-4'>
                        {report.status === 'READY_FOR_DOWNLOAD' ? (
                          <a href={report.storage_location} className='bg-[#134463] text-white px-4 py-1 hover:bg-[#134463da] rounded-full'>Download</a>
                        ) : ('---')}
                        <button className='text-red-600 bg-red-100 p-1 rounded-lg text-xl' onClick={() => handleDelete(report.id)}><MdDeleteForever/></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                <div className='grid place-items-center p-4'>
                  <h3><MdOutlineBlock /></h3>
                  <h4>No Data</h4>
                </div>
              </div>
            )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#eef1ff] border-slate-300 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <span>Showing {count} / {total} Reports</span>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Reports;